/**
 * @ignore
 * Created by daletan on 6/22/16.
 */

'use strict';

const React = require('react');

const PropTypes = require('prop-types');

// Stores
const UserStore = require('../../global/stores/UserStore.es');
const PriceStore = require('../../global/stores/PriceStore.es.js');
const ItemStore = require('../../newPdp/stores/ItemStore.es');

// Components
const FormattedPrice = require('./FormattedPrice');

// Styles
const styles = require('./pdp-price.scss');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const classnames = require('classnames');
const pageTypes = require('../../global/constants/pageTypes.es');
const get = require('lodash.get');

const ReducedPrice = props => {
    const { currency,
        originalPrice,
        salePrice,
        copy = {},
        pageType = 'pdp',
        showReducedFrom,
        isSoldIndividually,
        priceDisplays } = props;
    const reducedFromText = get(copy, 'priceStates.reducedFrom');
    const isPdp = pageType === pageTypes.PAGE_TYPE.PDP;
    const priceClasses = classnames('notranslate', {
        'pdp-price': isPdp,
        [styles.price]: isPdp,
        [styles.portfolio]: pageType === pageTypes.PAGE_TYPE.FAVORITES
    });

    return (
        <div>
            <div className={priceClasses} data-tn='item-details-price'>
                <FormattedPrice
                    isSoldIndividually={isSoldIndividually}
                    copy={copy}
                    priceDisplays={priceDisplays}
                    price={salePrice}
                    currency={currency}
                    type="reduced" />
            </div>
            { showReducedFrom ?
                <div className={`${styles.reduced} pdp-price-reduced notranslate`} data-tn="price-reduced">
                    {`${reducedFromText} `}
                    <FormattedPrice
                        isSoldIndividually={isSoldIndividually}
                        copy={copy}
                        priceDisplays={priceDisplays}
                        price={originalPrice}
                        currency={currency}
                        type="initial" />
                </div>
                : null }
        </div>
    );
};

ReducedPrice.defaultProps = {
    showReducedFrom: true
};

ReducedPrice.propTypes = {
    copy: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    salePrice: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    originalPrice: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]).isRequired,
    pageType: PropTypes.string,
    isSoldIndividually: PropTypes.bool,
    priceDisplays: PropTypes.object,
    showReducedFrom: PropTypes.bool
};

const Connected = provideContext(connectToStores(
    ReducedPrice,
    [
        ItemStore,
        PriceStore,
        UserStore
    ],
    context => {
        const userStore = context.getStore(UserStore);
        const itemStore = context.getStore(ItemStore);
        const priceStore = context.getStore(PriceStore);
        const item = itemStore.getItem();
        const processedPriceData = priceStore.processPrice(item);
        const { salePriceData = {},
            netPriceData = {},
            originalPriceData = {},
            retailPriceData = {} } = processedPriceData;
        return ({
            copy: itemStore.getCopy(),
            currency: userStore.getCurrency(),
            isSoldIndividually: itemStore.getSoldIndividually(netPriceData.model || retailPriceData.model),
            originalPrice: originalPriceData.price,
            pageType: pageTypes.PAGE_TYPE.PDP,
            priceDisplays: processedPriceData.priceDisplays,
            salePrice: salePriceData.price
        });
    }
));

module.exports = {
    Connected,
    Raw: ReducedPrice
};



// WEBPACK FOOTER //
// ./assets/js/components/Price/ReducedPrice.jsx